import { PROFILE_TYPES } from 'Const/investment';

export default function (profile) {
  if (!profile.id) return '';
  if (profile.type === PROFILE_TYPES.INDIVIDUAL) return 'Individual';
  if (profile.type === PROFILE_TYPES.SDIRA) {
    return `${profile.ownership.custodian} ${profile.personal.first_name} ${profile.personal.last_name}`;
  }
  if (profile.ownership) {
    if (profile.type === PROFILE_TYPES.TRUST) {
      return profile.ownership.trust_name;
    }
    if ([PROFILE_TYPES.ENTITY, PROFILE_TYPES.SOLO401K].includes(profile.type)) {
      return profile.ownership.entity_name;
    }
  }
  return `${profile.personal.first_name} ${profile.personal.last_name}`;
}
